export default class Env {
  static vidioChatHost() {
    return process.env.NEW_VIDIO_CHAT_HOST; /* jshint ignore:line */// envified
  }

  static vidioChatSecure() {
    return process.env.VIDIO_CHAT_SECURE; /* jshint ignore:line */// envified
  }

  static pnsPublicWebApiHost() {
    return process.env.PNS_PUBLIC_WEB_API_BASE_URL;
  }
}

